// components/Spinner.tsx
import { FC } from "react";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
}

export const Spinner: FC<SpinnerProps> = ({ size = "md" }) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  return (
    <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-[#383181] ${sizes[size]}`} />
  );
};